import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { OpeningLead } from '../components/OpeningLead';
import { EditorialTips } from '../components/EditorialTips';
import { PdfPreview } from '../components/PdfPreview';
import { Testimonials } from '../components/Testimonials';
import { WhatYouGet } from '../components/WhatYouGet';
import { Bonuses } from '../components/Bonuses';
import { PricingSection } from '../components/PricingSection';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { PriceComparison } from '../components/PriceComparison';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
import { DiscountPopup } from '../components/DiscountPopup';
import { Footer } from '../components/Footer';
import { OrderBumpProvider } from '../hooks/useOrderBumps';
function SalesPageContent() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-824">
      <Hero data-id="element-825" />
      <ProblemSection data-id="element-826" />
      <OpeningLead data-id="element-827" />
      <EditorialTips data-id="element-828" />
      <Testimonials data-id="element-829" />
      <PdfPreview data-id="element-830" />
      <WhatYouGet data-id="element-831" />
      <Bonuses data-id="element-832" />
      <PricingSection data-id="element-833" />
      <Guarantee data-id="element-834" />
      <FAQ data-id="element-835" />
      <PriceComparison data-id="element-836" />

      <Footer data-id="element-837" />
      <StickyCTA data-id="element-838" />
      <SocialProofToast data-id="element-839" />
      <DiscountPopup data-id="element-840" />
    </div>;
}
export function SalesPage() {
  return <OrderBumpProvider data-id="element-841">
      <SalesPageContent data-id="element-842" />
    </OrderBumpProvider>;
}